import React, { Component } from "react";

import { Container, Row, Col, Table, Form, Badge } from "react-bootstrap";

import CommonDataTableLoading from '../components/CommonDataTableLoading';
import CommonRowId from '../components/CommonRowId';
import CommonButton from '../components/CommonButton';
import CommonButtonBadge from '../components/CommonButtonBadge';
import CommonDropdown from '../components/CommonDropdown';
import CommonPagination from '../components/CommonPagination';
import CommonRecordNotFound from '../components/CommonRecordsNotFound';

import * as fn from '../../library/function';
import * as util from '../../library/utilitys';

class DataTableDemandDataManpowerEstablishments extends Component {

    render() {

        let props = this.props;

        let { onSetEdit, onNavigate, onReorder, onDropDownChange, onCheckDelete, onCheckDeleteAll, onPaginationChange } = props;

        let { Action, DataTable, Inputs, Deletes, Operation, UserCookie } = props;

        let rowId = fn.getRowIdStart(DataTable.pagination);

        let deleteChecked = 0;

        return (
            <Container fluid className="data-table-container">

                <CommonDataTableLoading isLoading={Action.Loading.dataTable} />
    
                <Row>
                    <Col md={12}>
                        {DataTable?.rows?.length > 0 ? 
                            <Table 
                                responsive 
                                borderless 
                                className={`table-advance ${!Action.Loading.dataTable ? 'table-visible' : ''}`}
                            >
                                <thead >
                                    <tr>
                                        <th className="th-td-align-center th-width-50p"></th>
                                        <th className="th-width-auto"></th>
                                        {/** <th className="th-width-200p"></th> */}
                                        <th className="th-width-50p"></th>
                                        <th className="th-td-align-center th-width-50p">
                                            {((deleteChecked > 0) || true) && (
                                                <Form.Check 
                                                    type="checkbox"
                                                    checked={Deletes.checkAll}
                                                    onChange={(e) => onCheckDeleteAll(e, fn.getCheckboxAllItem('deletes'))} 
                                                />
                                            )}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {DataTable.rows.map((row, index) => {
                                        
                                        Object.keys(row).forEach(key => { row[key] = util.renderText(row[key]); });

                                        rowId++;

                                        let del = true;

                                        return (
                                            <React.Fragment key={`${rowId}-${row.id}`}>
                                                <tr className={((rowId % 2) === 1) ? 'striped-row' : ''}>
                                                    <td className="th-td-align-center">
                                                        <CommonRowId rowId={rowId}/>
                                                    </td>
                                                    <td className="text-truncate" title={row.enterprise_name}>
                                                        {row.enterprise_name}

                                                        {(row.target_industries_name || row.position_name || row.positions) && (
                                                        <p className="title-xs mb-0 mt-1 d-flex flex-wrap align-items-center">
                                                            {row.target_industries_name && (
                                                            <>
                                                                <i className="fa-classic fa-light fa-industry-windows fa-fw me-2"></i>
                                                                <span className="me-2">{row.target_industries_name}</span>
                                                            </>
                                                            )}

                                                            {row.target_industries_name && row.position_name && (
                                                            <span className="me-2"></span>
                                                            )}

                                                            {row.position_name && (
                                                            <>
                                                                <i className="fa-classic fa-light fa-briefcase fa-fw me-2"></i>
                                                                ตำแหน่ง <span className="ms-1 me-2">{row.position_name}</span>
                                                            </>
                                                            )}

                                                            {(row.target_industries_name || row.position_name) && row.positions && (
                                                            <span className="me-2"></span>
                                                            )}

                                                            {row.positions && (
                                                            <>
                                                                <i className="fa-classic fa-light fa-circle-user fa-fw me-2"></i>
                                                                ความต้องการ <span className="ms-2">{util.formatNumber(row.positions, true)} ตำแหน่ง</span>
                                                            </>
                                                            )}
                                                        </p>
                                                        )}
                                                       
                                                        {(row.skills_set_rows > 0) && 
                                                            <p className="title-xs mb-0 mt-1">
                                                                <i className="fa-classic fa-regular fa-stars fa-fw me-2"></i>
                                                                ทักษะ Skills set 
                                                                <Badge className="badge-sm ms-2" pill bg="dark">{util.formatNumber(row.skills_set_rows, true)}</Badge>
                                                            </p>
                                                        }

                                                        {row.years && (
                                                            <p className="title-xs mb-0 mt-1">
                                                                <i className="fa-classic fa-light fa-calendar-check fa-fw me-2"></i>
                                                                ปีที่ต้องการแรงงาน
                                                                <span 
                                                                    className="badge badge-sm bg-success small pill mt-0 me-1 ms-2"
                                                                    style={{ fontSize: '0.7rem' }}
                                                                >
                                                                    {row.years}
                                                                </span>
                                                            </p>
                                                        )}
                                                    </td>
                                                    {/** 
                                                    <td>
                                                        <CommonButtonBadge 
                                                            info={{text: 'Skills Set', count: row.skills_set_rows}}
                                                            rounded={false}
                                                            disabled={false}
                                                            callback={(e) => onNavigate(e, { element: [{ id: 'manpower_establishments_id', value: row.id, label: row.position_name}] })} 
                                                        />
                                                    </td>
                                                    */}
                                                    <td className="th-td-align-center">
                                                        <CommonButton 
                                                            task="edit" 
                                                            rounded={false}
                                                            disabled={false}
                                                            callback={(e) => onSetEdit(e, {id: row.id})} 
                                                        />
                                                    </td>
                                                    <td className="th-td-align-center">
                                                        {del && (
                                                            <Form.Check 
                                                                type="checkbox"
                                                                name="deletes"
                                                                value={row.id}
                                                                checked={Deletes.deletes.includes(row.id)}
                                                                onChange={(e) => onCheckDelete(e)} 
                                                            />
                                                        )}
                                                    </td>
                                                </tr>
                                                <tr className="table-row-gap"><td /></tr>
                                            </React.Fragment>
                                        )
                                    })}
                                </tbody>
                            </Table>
                        :
                            <CommonRecordNotFound Action={Action} rows={DataTable.pagination.totalRows} />
                        }

                        {!Action.Loading.dataTable && (
                            <CommonPagination 
                                Pagination={DataTable.pagination} 

                                handlePagination={(paging) => onPaginationChange(paging)}
                            />
                        )}
                        
                    </Col>
                </Row>

            </Container>
        );
    }
}

export default DataTableDemandDataManpowerEstablishments;
